export const newEntityId = '00000000-0000-0000-0000-000000000000';

/**
 * Policy floor for the per-km platform fee, mirroring
 * FareConfiguration.PLATFORM_FEE_PER_KM_FLOOR on the server.
 *
 * Derivation: floor = insurance $/km x deadhead factor. Northbridge SPF No. 9 charges $0.25/km on
 * Periods 2 and 3, so break-even is $0.30/km at the 1.20 target deadhead ratio; $0.32 is the number
 * pricing policy settled on and corresponds to a 1.28 ratio. Going below it is a warning, never a
 * rejection — a re-quote or a measured deadhead ratio can legitimately move the number.
 */
export const PLATFORM_FEE_PER_KM_FLOOR = 0.32;
